/**
 * Упаковка снимка.
 *
 * Пока копия была одна, её вес значения не имел. Теперь их до двадцати двух, и
 * каждая — полная выгрузка всех данных: у человека с тремя годами записей это
 * мегабайты, помноженные на двадцать два. Браузер такому хранилищу не рад — он
 * начнёт вытеснять данные сайта, то есть ровно то, что мы бережём.
 *
 * JSON сжимается штатным механизмом браузера в разы: у него много повторов —
 * одни и те же имена полей в каждой записи. Сжатие есть везде, где работает
 * приложение, но если его вдруг нет, снимок кладётся как есть: копия важнее
 * экономии.
 *
 * Формат узнаётся по первым двум байтам gzip, а не по отдельному полю: так
 * снимок остаётся самодостаточным и не может разойтись со своим признаком.
 */

const GZIP_MAGIC = [0x1f, 0x8b];

function supported(): boolean {
  return typeof CompressionStream === 'function' && typeof DecompressionStream === 'function';
}

/**
 * Поток из одного куска: `Blob.stream()` есть не во всех средах.
 *
 * Тип потока — `BufferSource`: именно его принимает сжатие, и без этого
 * TypeScript не сводит `Uint8Array` с тем, что объявлено у браузера.
 */
function streamOf(chunk: Uint8Array<ArrayBuffer>): ReadableStream<BufferSource> {
  return new ReadableStream<BufferSource>({
    start(controller) {
      controller.enqueue(chunk);
      controller.close();
    },
  });
}

export async function packSnapshot(json: string): Promise<Uint8Array> {
  const raw = new TextEncoder().encode(json);
  if (!supported()) return raw;

  const packed = streamOf(raw).pipeThrough(new CompressionStream('gzip'));
  return new Uint8Array(await new Response(packed).arrayBuffer());
}

export async function unpackSnapshot(bytes: Uint8Array): Promise<string> {
  const gzipped = bytes[0] === GZIP_MAGIC[0] && bytes[1] === GZIP_MAGIC[1];
  if (!gzipped) return new TextDecoder().decode(bytes);

  // Копия байтов: из базы они приходят поверх произвольного буфера, а поток
  // принимает только собственный.
  const source = streamOf(new Uint8Array(bytes)).pipeThrough(new DecompressionStream('gzip'));
  return new Response(source).text();
}
